/**
 * Optional one-click login fill for admin.
 *
 * Shown when:
 * - `vite` dev server (`import.meta.env.DEV`), or
 * - build had `VITE_LOGIN_QUICK_FILL=true`, or
 * - page host is loopback.
 *
 * Not auto-enabled on emptystaging / staging / production admin hosts —
 * set `VITE_LOGIN_QUICK_FILL=true` at build time if you want the button there.
 */
function isLoopbackHost(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h === '[::1]';
}

export function isLoginQuickFillEnabled(): boolean {
  return Boolean(
    import.meta.env.DEV ||
      import.meta.env.VITE_LOGIN_QUICK_FILL === 'true' ||
      isLoopbackHost(),
  );
}

export function getAdminQuickLoginDefaults(): { username: string; password: string } {
  const fromEnvUser = import.meta.env.VITE_DEV_ADMIN_USERNAME;
  const fromEnvPass = import.meta.env.VITE_DEV_ADMIN_PASSWORD;

  if (typeof window !== 'undefined') {
    const h = window.location.hostname.toLowerCase();
    if (h === 'emptyadmin.orbs99.com' || h.startsWith('emptyadmin.')) {
      return {
        username: fromEnvUser || 'admin',
        password: fromEnvPass || 'ChangeMeEmpty!',
      };
    }
    if (h === 'stagingadmin.orbs99.com' || h.startsWith('stagingadmin.')) {
      return {
        username: fromEnvUser || 'admin',
        password: fromEnvPass || 'ChangeMeOnFirstLogin!',
      };
    }
  }

  return {
    username: fromEnvUser ?? 'admin',
    password: fromEnvPass ?? 'ChangeMeOnFirstLogin!',
  };
}
